import { RouteObject } from "react-router-dom";
import Dashboard from "../pages/dashboard/index";
import Bookmarks from "../pages/bookmark/index";
import Search from "../pages/search/index";
import Calendar from "../pages/calendar/index";
import Settings from "../pages/setting/index";
import Authentication from "../pages/authentication";
import Errors from "../pages/errors";
import Introduction from "../pages/introduction";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/bookmarks",
    element: <Bookmarks />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "/calendar",
    element: <Calendar />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/authentication",
    element: <Authentication />,
  },
  {
    path: "/errors",
    element: <Errors />,
  },
  {
    path: "/introduction",
    element: <Introduction />,
  },
];
